export function createCompassRose(
    imageSrc: string,
    imgSize = 40
): HTMLSpanElement {
    const span: HTMLSpanElement = document.createElement("span");
    const img: HTMLImageElement = document.createElement("img");

    img.src = imageSrc;
    img.alt = "Rosa dos Ventos";
    img.style.width = `${imgSize}px`;
    img.style.height = `${imgSize}px`;
    img.style.position = "absolute";

    span.appendChild(img);
    return span;
}
